export default function parseHtml(html) {
    const template = document.createElement('template');
    template.innerHTML = html ?? '';

    return template.content;
}
